export default "__VITE_ASSET__5o$H0e3I__"